(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('EconomicGroupFranchiserFormController', EconomicGroupFranchiserFormController)

    /** @ngInject */
    function EconomicGroupFranchiserFormController($q, $state, $stateParams, HelperService, sweetAlert, EconomicGroupService, ClusterPerformanceService) {
        const vm = this;
        const groupId = $stateParams.groupId;

        // ÁREA CUSTOM METHODS
        vm.saveGroup = () => {
            HelperService.startLoading('.loading-holder');

            let groupData = angular.copy(vm.groupData);

            if (vm.selectedClusterPerformance)
                groupData.ClusterPerformanceId = vm.selectedClusterPerformance.Id;

            if (!vm.groupData.Id) {
                EconomicGroupService
                    .post(groupData)
                    .then(success => successCallback(success, true), errorCallback);
            } else {
                EconomicGroupService
                    .put(groupData)
                    .then(success => successCallback(success, false), errorCallback);
            }
        }

        vm.deleteGroup = () => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Não é possível desfazer essa ação!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    HelperService.startLoading('.loading-holder');

                    EconomicGroupService
                        .deleteGroup(groupId)
                        .then(
                            () => {
                                $state.go('app.franchiser-economic-groups-list')
                                HelperService.stopLoading('.loading-holder');
                                HelperService.successCallback('delete');
                            }, error => {
                                HelperService.errorCallback(error);
                                HelperService.stopLoading('.loading-holder');
                            });
                }
            })
        }

        init();

        function getGroup() {
            if (!groupId) {
                HelperService.stopLoading('.loading-holder');
                return;
            }

            EconomicGroupService
                .get(groupId)
                .then(success => {
                    vm.groupData = success;

                    if (vm.groupData.ClusterPerformanceId)
                        vm.selectedClusterPerformance = vm.clustersPerformance.find(x => x.Id == vm.groupData.ClusterPerformanceId);

                    HelperService.stopLoading('.loading-holder');
                }, error => {
                    HelperService.stopLoading('.loading-holder');
                    HelperService.errorCallback(error);
                })
        }

        function getClustersPerformance() {
            return ClusterPerformanceService
                .getAll()
                .then(
                    success => vm.clustersPerformance = success,
                    error => HelperService.errorCallback(error)
                );
        }

        function successCallback(success, isPost) {
            if (isPost) {
                HelperService.successCallback();

                vm.groupData = success;

                $state.go('app.franchiser-economic-groups-edit', {
                    groupId: vm.groupData.Id
                }, {
                    notify: false
                });
            }

            HelperService.successCallback('update');
            HelperService.stopLoading('.loading-holder');
        }

        function errorCallback(error) {
            HelperService.stopLoading('.loading-holder');
            HelperService.errorCallback(error);
        }

        function init() {
            HelperService.startLoading('.loading-holder');

            $q.all([getClustersPerformance()])
                .then(() => {
                    getGroup();
                });
        }
    }
}());